// At BBC there will be only one such "prd" file. So far we keep the others till BBHC is fully migrated
export const environment = {
  production: window['env']['production'],
  apiUrl: window['env']['apiUrl'],
  loginUrl: window['env']['loginUrl'],
  logoutUrl: window['env']['logoutUrl'],
  issuer: window['env']['issuer'],
  clientId: window['env']['clientId'],
  trackingUi: {
    enable: window['env']['trackingUi.enable'],
    reportingUrl: window['env']['trackingUi.reportingUrl']
  },
  instanaApiKey: window['env']['instanaApiKey']
};
